import { Icon, IconProps, makeStyles } from '@material-ui/core';
import React from 'react';
import clsx from 'clsx';

export type FaIconProps = IconProps & {
    icon: string
    disableLeftMarginAdjustment?: boolean
}

export function FaIcon ({ icon, className, disableLeftMarginAdjustment, ...props}: FaIconProps) {
    const cls = useStyles();
    
    return (
        <Icon {...props} className={clsx(`fa ${icon} ${className}`, {
            [cls.leftMarginAdjustment]: disableLeftMarginAdjustment !== true            
        })} />
    );
}

const useStyles = makeStyles(theme => ({
    leftMarginAdjustment: {
        marginLeft: 3
    }
}));